import React from "react";
import Banner from "./Banner";
// import Services from "./Services";
// import Slider from "./Slider";
// import About from "./About";
// import Contact from "./Contact";

const Home = () => {
  return (
    <>
      <Banner />
      {/* <Services />
      <About />
      <Slider />
      <Contact /> */}
    </>
  );
};

export default Home;
